import Entity from './entity'
export default class Favorites extends Entity<number>{
}